import './Navbar.css';
import { Link } from "react-router-dom";
import { useState } from 'react';
import logo from '../media/tourism/logo.jpg';
export const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav>
      <div className="logo">
        <Link to="/"><img src={logo} alt="Logo" className="navbar-logo" />
        <span className="navbar-title">Sonbhadra Tourism</span></Link>
        <p>Travel made easy</p>
      </div>
      <input
        type="checkbox"
        id="check"
        checked={isMenuOpen}
        onChange={handleMenuToggle}
      />
      <label htmlFor="check" className="checkbtn">
        <i className="fa fa-bars"></i>
      </label>

      <ul className="list">
        <li id="active"><Link to="/aboutus" onClick={handleMenuItemClick}>About Us</Link></li>
        <li><Link to="/book" id="d" onClick={handleMenuItemClick}>Book</Link></li>
        <li><Link to="/packages" id="d" onClick={handleMenuItemClick}>Packages</Link></li>
         {/* <li id="drop">
          <Link to="/locations" id="d" onClick={handleMenuItemClick}>Places</Link>
          <ul>
            <li><Link to="/locations" id="d" onClick={handleMenuItemClick}>All Places</Link></li>
            <li><Link to="/locations/uttarakhand" id="d" onClick={handleMenuItemClick}>Top</Link></li>
          </ul>
        </li> */}
        {/* <li id="drop">
          <Link to="/locations" id="d" onClick={handleMenuItemClick}>International</Link>
          <ul>
            <li><Link to="/locations/dubai" id="d" onClick={handleMenuItemClick}>Dubai</Link></li>
            <li><Link to="/locations/europe" id="d" onClick={handleMenuItemClick}>Europe</Link></li>
            <li><Link to="/locations/srilanka" id="d" onClick={handleMenuItemClick}>SriLanka</Link></li>
            <li><Link to="/locations/thailand" id="d" onClick={handleMenuItemClick}>Thailand</Link></li>
            <li><Link to="/locations/maldives" id="d" onClick={handleMenuItemClick}>Maldives</Link></li>
            <li><Link to="/locations" id="d" onClick={handleMenuItemClick}>View all..</Link></li>
          </ul>
        </li> */}
        <li><Link to="/locations" id="d" onClick={handleMenuItemClick}>Places</Link></li>
        <li><Link to="/article" id="d" onClick={handleMenuItemClick}>Article</Link></li>
        
        <li><Link to="/contact" id="d" onClick={handleMenuItemClick}>Contact Us</Link></li>

      </ul>
    </nav>
  );
};
